import { UserRole } from "imagine-users";
import {
  Defect,
  DefectStatus,
  DefectStatusEntry,
  PunchlistText,
  StatusIcon,
  StatusIconSelect,
  StatusSelect,
} from "../..";
import { useTranslation } from "react-i18next";

interface Props {
  defect: Defect;
  userRole: UserRole;
  onChange?: (defect: Defect) => void;
  onSave?: (status: DefectStatusEntry) => void;
  readonly?: boolean;
  mode: "select" | "modal";
}

export const StatusEditor = (props: Props) => {
  const { t } = useTranslation();

  const update = (status: Partial<Defect>) => {
    const updatedDefect = { ...props.defect, ...status };
    if (props.onChange) {
      props.onChange(updatedDefect);
    }
  };

  return (
    <div className="">
      <div className="status-editor-grid ">
        <div className="row items-y-center">{t("punchlist:resident")}:</div>
        <div className="row items-y-center">
          <StatusIconSelect
            status={props.defect.residentStatus}
            onChange={(status) => update({ residentStatus: status })}
            onSave={props.onSave}
            readonly={
              props.userRole !== UserRole.NONE &&
              props.userRole !== UserRole.ADMIN
            }
            mode={props.mode}
            className="stretch ml-sm ml-none--xs mb-sm--xs"
            userRole={UserRole.NONE}
          />
        </div>

        <div className="row items-y-center">{t("punchlist:contractor")}:</div>
        <div className="row items-y-center">
          <StatusIconSelect
            status={props.defect.contractorStatus}
            onChange={(status) => update({ contractorStatus: status })}
            onSave={props.onSave}
            readonly={props.userRole !== UserRole.PREMIUM}
            mode={props.mode}
            className="stretch ml-sm ml-none--xs mb-sm--xs"
            userRole={props.userRole}
          />
        </div>

        <div className="row items-y-center">{t("punchlist:manager")}:</div>
        <div className="row items-y-center">
          <StatusIconSelect
            status={props.defect.managerStatus}
            onChange={(status) => update({ managerStatus: status })}
            onSave={props.onSave}
            readonly={
              props.userRole !== UserRole.MODERATOR &&
              props.userRole !== UserRole.ADMIN
            }
            mode={props.mode}
            className="stretch ml-sm ml-none--xs mb-sm--xs"
            userRole={props.userRole}
          />
        </div>

        {props.mode === "modal" && (
          <>
            <div className="colspan-2 spacer"></div>

            <div className="text-no-wrap row items-y-center">
              {t("punchlist:lastStatus")}:
            </div>

            <div className="row items-y-center">
              <StatusIconSelect
                status={props.defect.status || DefectStatus.NONE}
                onSave={props.onSave}
                mode={props.mode}
                className="stretch ml-sm ml-none--xs mb-sm--xs"
                userRole={props.userRole}
              />
            </div>
          </>
        )}
      </div>
    </div>

    // <div className="column gap-sm">
    //   <div className="row items-y-center">
    //     <div>{t("punchlist:resident")}:</div>
    //     <StatusIconSelect
    //       status={props.defect.residentStatus}
    //       onChange={(status) => update({ residentStatus: status })}
    //       readonly={props.userRole !== UserRole.NONE}
    //       className="stretch ml-sm"
    //     />
    //   </div>
    //   <div className="row items-y-center">
    //     <div>{t("punchlist:contractor")}:</div>
    //     <StatusIconSelect
    //       status={props.defect.contractorStatus}
    //       onChange={(status) => update({ contractorStatus: status })}
    //       readonly={props.userRole !== UserRole.PREMIUM}
    //       className="stretch ml-sm"
    //     />
    //   </div>
    //   <div className="row items-y-center">
    //     <div>{t("punchlist:manager")}:</div>
    //     <StatusIconSelect
    //       status={props.defect.managerStatus}
    //       onChange={(status) => update({ managerStatus: status })}
    //       readonly={
    //         props.userRole !== UserRole.MODERATOR &&
    //         props.userRole !== UserRole.ADMIN
    //       }
    //       className="stretch ml-sm"
    //     />
    //   </div>
    // </div>
  );
};
